<script setup>
import { onMounted, onBeforeMount } from "vue";
import { useUser } from "@/hooks/useUser";
import NavbarComponent from "@/components/Dashboard/NavbarComponent.vue";
import SidebarComponent from "@/components/Dashboard/SidebarComponent.vue";

const { getUser } = useUser();

onBeforeMount(async () => {
  await getUser();
});

onMounted(() => {
  setTimeout(() => {
    window.dispatchEvent(new Event("resize"));
  }, 2500);
});
</script>

<template>
  <div class="dashboard-main-view dark-mode sidebar-mini">
    <div class="wrapper">
      <NavbarComponent />
      <SidebarComponent />
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
      <aside class="control-sidebar control-sidebar-dark"></aside>
    </div>
  </div>
</template>

<style scoped>
.dashboard-main-view {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content-wrapper {
  flex: 1;
  padding-bottom: 5rem;
  overflow-y: auto;
}
</style>
